// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fd3d089c","239":"9b0d786d","453":"61c904e8","455":"a4934a81"}[chunkId] + ".chunk.js";
};